/**
 * Normalize addon selections on a cart line for stable ordering.
 */
export function normalizeCartAddons(addons) {
  if (!addons || !addons.length) return [];
  return [...addons].sort((a, b) => {
    const ca = String(a.addon_category_id ?? "");
    const cb = String(b.addon_category_id ?? "");
    if (ca !== cb) return ca.localeCompare(cb);
    return String(a.addon_id ?? "").localeCompare(String(b.addon_id ?? ""));
  });
}

/**
 * Compare cart lines by variant (category + addon id), ignoring field order
 * and harmless differences (e.g. price as string vs number).
 */
export function areCartAddonsEqual(a, b) {
  const left = normalizeCartAddons(a);
  const right = normalizeCartAddons(b);
  if (left.length !== right.length) return false;
  return left.every(
    (addon, index) =>
      String(addon.addon_category_id) ===
        String(right[index].addon_category_id) &&
      String(addon.addon_id) === String(right[index].addon_id)
  );
}

/** Same product id and equivalent addon selections. */
export function isSameCartLine(a, b) {
  return Boolean(a && b && a.id === b.id && areCartAddonsEqual(a.selectedaddons, b.selectedaddons));
}
